import { useEffect } from "react";

function setMeta(attr: "name" | "property", key: string, content: string) {
  let element = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
  if (!element) {
    element = document.createElement("meta");
    element.setAttribute(attr, key);
    document.head.appendChild(element);
  }
  element.setAttribute("content", content);
}

function setCanonical(href: string) {
  let link = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]');
  if (!link) {
    link = document.createElement("link");
    link.setAttribute("rel", "canonical");
    document.head.appendChild(link);
  }
  link.setAttribute("href", href);
}

interface PageMetaOptions {
  title: string;
  description: string;
  keywords?: string;
  canonical?: string;
}

export function usePageMeta({ title, description, keywords, canonical }: PageMetaOptions) {
  useEffect(() => {
    document.title = title;
    setMeta("name", "description", description);
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    if (keywords) setMeta("name", "keywords", keywords);
    if (canonical) {
      setCanonical(canonical);
      setMeta("property", "og:url", canonical);
    }
  }, [title, description, keywords, canonical]);
}